import React from 'react';
import { Link } from 'react-router-dom';


const PrivacyPolicy = () => {

  return (
    <>
    <div className='background'></div>
    <div className="content-wrapper">
    <div className='container-terms'>
    <div className='alignment-left bg'>

    <div>
    <h1 className='h1-terms'>Privacy Policy</h1>
    <p style={{fontWeight: "300", fontStyle: 'italic'}}>Effective date: April 7, 2025.</p>

    <p style={{fontWeight: "300"}}>
    Outplan ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy 
    explains how we collect, use, disclose, and safeguard your information when you use our SaaS 
    application, Outplan ("Service"). By using the Service, you agree to the collection and use 
    of information in accordance with this policy. If you do not agree with the terms of this 
    Privacy Policy, please do not access the Service.
    </p>
    
    <h5 className='h5-terms'><b>1. Information We Collect</b></h5>

    <p style={{margin: "0.5rem 0rem"}}><b>a. Personal Information:</b></p>
    <p style={{fontWeight: "300"}}>
    We may collect personal information you provide directly to us, such as:</p>
    <ul>
      <li style={{fontWeight: "300"}}>Name</li>
      <li style={{fontWeight: "300"}}>E-mail address</li>
      <li style={{fontWeight: "300"}}>Account login credentials</li>
      <li style={{fontWeight: "300"}}>Company name</li>
      <li style={{fontWeight: "300"}}>Payment information (via secure third-party processor)</li>
    </ul>

    <p style={{margin: "0.5rem 0rem"}}><b>b. Usage Data:</b></p>
    <p style={{fontWeight: "300"}}>
    We may collect information about how you access and use the Service, including:</p>
    <ul>
      <li style={{fontWeight: "300"}}>IP address</li>
      <li style={{fontWeight: "300"}}>Browser type and version</li>
      <li style={{fontWeight: "300"}}>Pages of our Service that you visit</li>
      <li style={{fontWeight: "300"}}>Time and date of your visit</li>
      <li style={{fontWeight: "300"}}>Time spent on those pages</li>
      <li style={{fontWeight: "300"}}>Unique device identifiers</li>
      <li style={{fontWeight: "300"}}>Other diagnostic data</li>
    </ul>
    <p style={{margin: "0.5rem 0rem"}}><b>c. Cookies and Tracking Technologies:</b></p>
    <p style={{fontWeight: "300"}}>
    We may use cookies and similar tracking technologies to track the activity on our Service
    and store certain information. Cookies are files with small amounts of data which may include
    an anonymous unique identifier. You can instruct your browser to refuse all cookies or to
    indicate when a cookie is being sent. However, if you do not accept cookies, you may not be
    able to use some portions of our Service. Examples of Cookies we use:
    <ul>
      <li style={{fontWeight: "300"}}>Session Cookies: We use Session Cookies to operate our Service.</li>
      <li style={{fontWeight: "300"}}>Preference Cookies: We use Preference Cookies to remember your preferences and various settings.</li>
      <li style={{fontWeight: "300"}}>Security Cookies: We use Security Cookies for security purposes.</li>
    </ul>
    </p>
    <p style={{margin: "0.5rem 0rem"}}><b>d. Third-Party Services:</b></p>
    <p style={{fontWeight: "300"}}>
    We may use third-party services to collect, monitor, and analyze the use of our Service.
    These third-party service providers have access to your Personal Information only to perform
    these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
    </p>
    <p style={{margin: "0.5rem 0rem"}}><b>e. Links to Other Sites:</b></p>
    <p style={{fontWeight: "300"}}>
    Our Service may contain links to other sites that are not operated by us. If you click on a
    third-party link, you will be directed to that third party's site. We strongly advise you to
    review the Privacy Policy and terms of service of any site you visit. We have no control over
    and assume no responsibility for the content, privacy policies, or practices of any third-party
    sites or services.
    </p>

    <h5 className='h5-terms'><b>2. How We Use Personal Information</b></h5>
    <p style={{fontWeight: "300"}}>
    We use the collected information to:
    </p>
    <ul>
      <li style={{fontWeight: "300"}}>Provide and maintain our Service</li>
      <li style={{fontWeight: "300"}}>Process payments and manage subscriptions</li>
      <li style={{fontWeight: "300"}}>Communicate with you (support, updates, newsletters)</li>
      <li style={{fontWeight: "300"}}>Improve user experience and analyze trends</li>
      <li style={{fontWeight: "300"}}>Detect and prevent fraud or abuse</li>
      <li style={{fontWeight: "300"}}>Comply with legal obligations</li>
      <li style={{fontWeight: "300"}}>Enforce our terms and conditions</li>
      <li style={{fontWeight: "300"}}>Respond to your inquiries and provide customer support</li>
      <li style={{fontWeight: "300"}}>Monitor the usage of our Service</li>
      <li style={{fontWeight: "300"}}>Detect, prevent and address technical issues</li>
      <li style={{fontWeight: "300"}}>Any other purpose with your consent</li>
    </ul>

    <h5 className='h5-terms'><b>3. Sharing Personal Information</b></h5>
    <p style={{fontWeight: "300"}}>
    We do not sell your personal information. We may share your data with:
    </p>
    <ul>
      <li style={{fontWeight: "300"}}>Service providers (e.g., hosting, analytics, payment processors)</li>
      <li style={{fontWeight: "300"}}>Legal authorities when required by law</li>
      <li style={{fontWeight: "300"}}>In the event of a business transfer or merger</li>
    </ul>

    <h5 className='h5-terms'><b>4. Your Rights and Choices</b></h5>

    <p style={{fontWeight: "300"}}>
    Depending on your location, you may have the right to:
    </p>
    <ul>
      <li style={{fontWeight: "300"}}>Access, update or delete the information we have on you.</li>
      <li style={{fontWeight: "300"}}>Object. You have the right to object to our processing of your Personal Information.</li>
      <li style={{fontWeight: "300"}}>Restriction. You have the right to request that we restrict the processing of your personal information.</li>
      <li style={{fontWeight: "300"}}>Withdraw consent. You also have the right to withdraw your consent at any time where Outplan relied on 
        your consent to process your personal information.</li>
      <li style={{fontWeight: "300"}}>Lodge a complaint with a data protection authority.</li>
    </ul>

    To make a request, contact us at <b>outplanapp@gmail.com</b>.

    <p style={{margin: "0.5rem 0rem"}}><b>a. Your Data Protection Rights Under General Data Protection Regulation (GDPR):</b></p>
    <p style={{fontWeight: "300"}}>
    If you are a resident of the European Economic Area (EEA), you have certain data protection
    rights. Outplan aims to take reasonable steps to allow you to correct, amend, delete or limit
    the use of your Personal Information. If you wish to be informed about what Personal Information
    we hold about you and if you want it to be removed from our systems, please contact us. In
    certain circumstances, you have the following data protection rights:
    <ul>
      <li style={{fontWeight: "300"}}>The right to access, update or delete the information we have on you.</li>
      <li style={{fontWeight: "300"}}>The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.</li>
      <li style={{fontWeight: "300"}}>The right to object. You have the right to object to our processing of your Personal Information.</li>
      <li style={{fontWeight: "300"}}>The right of restriction. You have the right to request that we restrict the processing of your personal information.</li>
      <li style={{fontWeight: "300"}}>The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.</li>
      <li style={{fontWeight: "300"}}>The right to withdraw consent. You also have the right to withdraw your consent at any time where Outplan relied on your consent to process your personal information.</li>
    </ul>
    </p>
    <p style={{fontWeight: "300"}}>
    Please note that we may ask you to verify your identity before responding to such requests. You
    have the right to complain to a Data Protection Authority about our collection and use of your
    Personal Information. For more information, please contact your local data protection authority.
    </p>
    <p style={{margin: "0.5rem 0rem"}}><b>b. Your Data Protection Rights Under California Privacy Rights Act (CPRA):</b></p>
    <p style={{fontWeight: "300"}}>
    If you are a California resident, you have the right to request information from us regarding
    the disclosure of your personal information to third parties for their direct marketing purposes.
    To make such a request, please contact us at the email address provided below. We will respond
    to your request within thirty (30) days of receiving it. Please note that we are only required
    to respond to one request per calendar year. In your request, please attest to the fact that you
    are a California resident and provide a current California address for us to respond to your
    request. We are not responsible for notices that are not labeled or sent properly, or do not
    have complete information. We may request additional information from you to verify your
    identity and for security or fraud prevention purposes. We will not discriminate against you
    for exercising any of your rights under the CPRA. If you are a California resident under 18
    years of age and a registered user of the Service, you have the right to request and obtain
    removal of unwanted data that you publicly post on the Service. To request removal of such
    data, please contact us using the contact information provided below, and include the email
    address associated with your account and a statement that you reside in California. We will
    make sure the data is not publicly displayed on the Service, but please be aware that the data
    may not be completely or comprehensively removed from our systems and databases.
    </p>
    <p style={{margin: "0.5rem 0rem"}}><b>c. Your Data Protection Rights Under Personal Information Protection and Electronic Documents Act (PIPEDA):</b></p>
    <p style={{fontWeight: "300"}}>
    If you are a resident of Canada, you have certain data protection rights. Outplan aims to take
    reasonable steps to allow you to correct, amend, delete or limit the use of your Personal
    Information. If you wish to be informed about what Personal Information we hold about you and
    if you want it to be removed from our systems, please contact us. In certain circumstances,
    you have the following data protection rights:
    <ul>
      <li style={{fontWeight: "300"}}>The right to access, update or delete the information we have on you.</li>
      <li style={{fontWeight: "300"}}>The right of rectification. You have the right to have your information rectified if that information is inaccurate or incomplete.</li>
      <li style={{fontWeight: "300"}}>The right to object. You have the right to object to our processing of your Personal Information.</li>
      <li style={{fontWeight: "300"}}>The right of restriction. You have the right to request that we restrict the processing of your personal information.</li>
      <li style={{fontWeight: "300"}}>The right to data portability. You have the right to be provided with a copy of the information we have on you in a structured, machine-readable and commonly used format.</li>
      <li style={{fontWeight: "300"}}>The right to withdraw consent. You also have the right to withdraw your consent at any time where Outplan relied on your consent to process your personal information.</li>
    </ul>
    </p>
    <p style={{fontWeight: "300"}}>
    Please note that we may ask you to verify your identity before responding to such requests. You
    have the right to complain to a Data Protection Authority about our collection and use of your
    Personal Information. For more information, please contact your local data protection authority.
    </p>

    <h5 className='h5-terms'><b>5. Data Security</b></h5>
    <p style={{fontWeight: "300"}}>
    The security of your Personal Information is important to us, but remember that no method of
    transmission over the Internet, or method of electronic storage is 100% secure. While we strive
    to use commercially acceptable means to protect your Personal Information, we cannot guarantee
    its absolute security. We will take all steps reasonably necessary to ensure that your data is
    treated securely and in accordance with this Privacy Policy and no transfer of your Personal
    Information will take place to an organization or a country unless there are adequate controls
    in place including the security of your data and other personal information.
    </p>

    <h5 className='h5-terms'><b>6. Data Retention</b></h5>
    <p style={{fontWeight: "300"}}>
    Outplan will retain your Personal Information only for as long as is necessary for the
    purposes set out in this Privacy Policy. We will retain and use your Personal Information to
    the extent necessary to comply with our legal obligations (for example, if we are required to
    retain your data to comply with applicable laws), resolve disputes, and enforce our legal
    agreements and policies. Outplan will also retain Usage Data for internal analysis purposes.
    Usage Data is generally retained for a shorter period of time, except when this data is used to
    strengthen the security or to improve the functionality of our Service, or we are legally
    obligated to retain this data for longer time periods.
    </p>

    <h5 className='h5-terms'><b>7. International Transfers</b></h5>
    <p style={{fontWeight: "300"}}>
    Your information, including Personal Information, may be transferred to — and maintained on —
    computers located outside of your state, province, country or other governmental jurisdiction
    where the data protection laws may differ from those of your jurisdiction. If you are located
    outside European Union and choose to provide information to us, please note that we transfer
    the data, including Personal Information, to European Union and process it there. Your consent
    to this Privacy Policy followed by your submission of such information represents your
    agreement to that transfer. Outplan will take all steps reasonably necessary to ensure that
    your data is treated securely and in accordance with this Privacy Policy and no transfer of
    your Personal Information will take place to an organization or a country unless there are
    adequate controls in place including the security of your data and other personal
    information.
    </p>

    <h5 className='h5-terms'><b>8. Children’s Privacy</b></h5>
    <p style={{fontWeight: "300"}}>
    Our Service does not address anyone under the age of 13 ("Children"). We do not knowingly
    collect personally identifiable information from anyone under the age of 13. If you are a
    parent or guardian and you are aware that your child has provided us with Personal Information,
    please contact us. If we become aware that we have collected Personal Information from
    children without verification of parental consent, we take steps to remove that information
    from our servers.
    </p>

    <h5 className='h5-terms'><b>9. Changes to the Privacy Policy</b></h5>
    <p style={{fontWeight: "300"}}>
    We may update this Privacy Policy. We’ll notify you of significant changes via email or a notice on the Service.
    We encourage you to review this Privacy Policy periodically for any changes. Changes to this
    Privacy Policy are effective when they are posted on this page. We will let you know via email
    and/or a prominent notice on our Service, prior to the change becoming effective and update
    the "effective date" at the top of this Privacy Policy. You are advised to review this Privacy
    Policy periodically for any changes. Changes to this Privacy Policy are effective when they are
    posted on this page. We will let you know via email and/or a prominent notice on our Service,
    prior to the change becoming effective and update the "effective date" at the top of this
    Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
    </p>

    <h5 className='h5-terms'><b>10. Contact Us</b></h5>
    <p style={{fontWeight: "300"}}>
      outplanapp@gmail.com
    </p>

    </div>
    </div>

    </div>

    <div className="footer-container">
    <Link to="/home" className="footer">Home</Link>
    <div className='vertical-line'></div>
    <Link to="/terms" className="footer">Terms</Link>
    <div className='vertical-line'></div>
    <Link to="/privacy" className="footer">Privacy</Link>
    </div>

    <div style={{paddingBottom: "1rem", paddingTop: "1rem", color: 'white'}}>
      <p className="copyright">&copy; 2025 Luminicent Design Oy. All rights reserved.</p>
    </div>

    </div>
    </>

  );
};

export default PrivacyPolicy;
